import React, { useState, useEffect } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { showCorporation } from '~/config/routes';
import Request from '~/providers/Request';
import CorporationRecord from '~/records/CorporationRecord';
import Form from './Form';
import handleDataAttributes from './utils/handleDataAttributes';
import dig from 'object-dig';
import { toast } from 'react-toastify';
import _ from 'lodash';

function EditRecord({ history }) {
  const [record, setRecord] = useState(new CorporationRecord());
  const [loading, setLoading] = useState(false);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id) {
      setLoading(true);
      Request.get(`/admin/corporation/${id}`, {})
        .then((response) => {
          setLoading(false);

          const corporation_type =
            response.data.corporation_type ||
            (response.data.config_corporation &&
              response.data.config_corporation.corporation_type) ||
            'Cliente';

          if (response.data.config_corporation === null || response.data.config_corporation === undefined) {
            response.data.config_corporation = {
              required_location: null,
              required_cns: null,
              required_documents: null,
              has_benefits_club: null,
            };
          }

          response.data.config_corporation.corporation_type = corporation_type;

          setRecord(
            record.updateAttributes(handleDataAttributes(response.data))
          );
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord((prevRecord) => {
      // Se o país não mudou, apenas atualiza os atributos sem resetar
      if (
        !attrs ||
        !prevRecord ||
        !attrs.country ||
        !prevRecord.country ||
        attrs.country.id === parseInt(prevRecord.country.id)
      ) {
        return prevRecord.updateAttributes(attrs);
      }

      return prevRecord.updateAttributes({
        ...prevRecord,
        country: attrs.country,
        name: '',
        email: '',
        phone: '',
        cnpj: '',
        street: '',
        district: '',
        number: '',
        postal_code: '',
        contact_name: '',
        contact_phone: '',
        contract_expires_at: '',
        disabled_at: null,
        frozen_at: null,
        city: null,
        is_driving: false,
        is_doctor: false,
        is_doctor_all: false,
        is_plan: false,
        is_emergency: false,
        partner: null,
        users_limit: null,
        corporation: null,
        owners: [],
        specialties: [],
        packs: [],
        corporation_doctors: [],
        config_corporation: {
          required_cns: true,
          required_location: true,
          required_documents: false,
          has_benefits_club: false,
          required_email: true,
          user_welcome_email: false,
          corporation_type: null,
          wallet_id: '',
          landing_url: '',
          accession_percentage: 0,
          signature_percentage: 0,
          income_value: 0,
        },
      });
    });
  };

  async function onSubmit() {
    // Validar se o tipo de empresa foi selecionado
    const config = record.get('config_corporation') || {};
    if (config.corporation_type === null || config.corporation_type === undefined) {
      toast.error('Tipo de empresa é obrigatório');
      return;
    }

    // Validações específicas
    const validationErrors = record.validateCorporationFields();
    if (validationErrors.length > 0) {
      validationErrors.forEach(error => toast.error(error));
      return;
    }

    setLoading(true);

    try {

      const data = _.cloneDeep(record.toParams({
        owner_id: dig(record.get('owner'), 'id'),
        corporation_id: dig(record.get('corporation'), 'id') || null,
      }));

      // Remover corporation_type se for 'Cliente'
      if (config.corporation_type === 'Cliente') {
        data.data.attributes.config_corporation.corporation_type = null;
      }

      data.data.attributes.country_id = data.data.attributes.country.id;
      if (data.data.attributes.country.id === 2) {
        delete data.data.attributes.city_id;
        delete data.data.attributes.owner_id;
      }

      // se a data de expiração for retroativa, retorna erro
      if (data.data.attributes.contract_expires_at) {
        const dateFormated = new Date(data.data.attributes.contract_expires_at);
        const today = new Date();
        const actualDateMidnight = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          0,
          0,
          0
        );

        if (dateFormated < actualDateMidnight) {
          setLoading(false);
          toast.error('Data de expiração do contrato não pode ser retroativa');
          return false;
        }
      }

      const resp = await Request.put(
        `/admin/corporation/${id}`,
        data,
        {},
        { controller: 'corporation' }
      );

      setLoading(false);
      history.push(showCorporation.reverse(resp.data));
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
      edit={true}
    />
  );
}

EditRecord.propTypes = {
  history: historyPropType,
};

export default EditRecord;
